import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { TextToSpeech } from 'widgets/TextToSpeech'
import { useAICallingAgentManageContext } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/context'
import { GreetingVoicesContent } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/Greeting/GreetingVoicesContent'
import { GreetingVoiceConfigStore } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/Greeting/store/GreetingVoiceConfigStore'

export const Greeting = observer(() => {
  const { greetingStore } = useAICallingAgentManageContext()
  useEffect(greetingStore.init, [])

  const { textToSpeechWidgetStore } = greetingStore

  return (
    <TextToSpeech
      store={greetingStore.textToSpeechWidgetStore}
      title={'Greeting message'}
      customComponent={(onCloseMenu) =>
        textToSpeechWidgetStore.configStore instanceof GreetingVoiceConfigStore && (
          <GreetingVoicesContent
            onCloseMenu={onCloseMenu}
            store={textToSpeechWidgetStore.configStore}
          />
        )
      }
    />
  )
})
